import React from 'react'
import ProjectResultCardComponent from '../../../Components/card/projectResultCard'

const DatalistSection = ({projectesData}) => {

    return (
        <div className="flex flex-col gap-4"> {/* Use flex column layout for vertical arrangement */}
            {projectesData.length > 0 ? (
                projectesData.map((projectData, index) => (
                    <ProjectResultCardComponent key={index} projectData={projectData} />
                ))
            ) : (
                <p>No services available.</p> // Placeholder text when no data is available
            )}
        </div>
    )
}

export default DatalistSection